import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const initializeAuth = ({
  user,
  gates,
  portal
}) => ({
  type: INITIALIZE_AUTH,
  user,
  gates,
  portal
});
export const getAuth = () => dispatch => {
  PortalIdParser.get();
  return userInfo().then(info => {
    return dispatch(initializeAuth(info));
  });
};